<template>
    <div>
        <main-container>
            <v-container class="convention-presentation">
                <v-row>
                    <v-col cols="11">
                        <convention-body :body="convention.description" />
                    </v-col>
                </v-row>
            </v-container>
        </main-container>
        <sep name="XL"></sep>
        <div class="background">
            <main-container>
                <v-container>
                    <convention-push-section :convention="convention" :user="user" />
                </v-container>
            </main-container>
        </div>
    </div>
</template>

<script>
import ConventionBody from "src/components/convention/ConventionBody.vue";
import ConventionPushSection from "src/components/convention/push/ConventionPushSection.vue";

export default {
    components: { ConventionBody, ConventionPushSection },
    props: ["convention", "user"],
};
</script>

<style scoped lang="sass">
.background
    background: lighten($color-pink, 13%)
.convention-presentation
    background: $color-background
    padding: $grid-gutter * 1.5 $grid-gutter * 2

@media print
    .convention-presentation
        margin-top: 8mm
        padding: 0
        background: white

    .row
        margin: 0

    .col
        padding: 0
        flex: 0 0 auto
        width: auto
        max-width: 100%

    .background
        display: none
</style>
